export default __webpack_public_path__ + "static/media/arcos2_g.9d5c2aa7.jpg";